import { BrowserModule } from '@angular/platform-browser';
import { ApplicationRef, DoBootstrap, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErzeugungsanlageModule } from './erzeugungsanlage/erzeugungsanlage.module';
import { MaterialModule } from './common/material/material.module';
import { WestnetzModule } from './common/westnetz/westnetz.module';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './service/auth/auth.guard';
import { ImportWizardModule } from './ea-import-wizard/import-wizard.module';
import { KontaktModule } from './kontakt/kontakt.module';
import { NetzzuordnungenModule } from './netzzuordnungen/netzzuordnungen.module';
import { DatenabfrageModule } from './datenabfrage/datenabfrage.module';
import { PipeModule } from './common/pipe/pipe.module';
import { SettingsModule } from './settings/settings.module';
import { NetzbetreiberModule } from './netzbetreiber/netzbetreiber.module';
import { DashboardModule } from './dashboard/dashboard.module';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { environment } from '../environments/environment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    MAT_MOMENT_DATE_FORMATS,
    MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { ImportNzIdWizardModule } from './nzId-import-wizard/import-nz-id-wizard.module';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { SessionInterceptor } from './service/auth/session.interceptor';
import { OAuth2AuthGuard } from './service/auth/oauth2.guard';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { GermanPaginatorIntl } from './common/material/german-paginator-intl';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { GermanDatepickerIntl } from './common/material/german-datepicker-intl';

registerLocaleData(localeDe);

const INTERCEPTORS = [
    SessionInterceptor,
];

const GUARDS = [
    AuthGuard,
    OAuth2AuthGuard,
];

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        MaterialModule,
        ErzeugungsanlageModule,
        DatenabfrageModule,
        NetzzuordnungenModule,
        ImportWizardModule,
        ImportNzIdWizardModule,
        WestnetzModule,
        KontaktModule,
        SettingsModule,
        NetzbetreiberModule,
        DashboardModule,
        PipeModule,
        environment.envModules,
    ],
    providers: [
        INTERCEPTORS,
        GUARDS,
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [
                MAT_DATE_LOCALE,
                MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            ],
        },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: {
                hasBackdrop: true,
                ariaModal: true,
                restoreFocus: true,
                delayFocusTrap: true,
                autoFocus: 'first-tabbable',
            } as MatDialogConfig,
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline',
                floatLabel: 'always',
                subscriptSizing: 'dynamic',
            } as MatFormFieldDefaultOptions,
        },
        {
            provide: MatPaginatorIntl,
            useClass: GermanPaginatorIntl,
        },
        {
            provide: MatDatepickerIntl,
            useClass: GermanDatepickerIntl,
        },
    ],
})
export class AppModule implements DoBootstrap {

    ngDoBootstrap(appRef: ApplicationRef) {
        console.log('Starting TNB-Portal');
        appRef.bootstrap(AppComponent);
    }
}
